module.exports = __webpack_public_path__ + "img/logo.5ebd48f2.png";